module.exports = __webpack_public_path__ + "img/hemline sweep.3234e142.png";